import React from 'react'
import Avatar from 'components/Avatar'
import { AvatarWithIconT } from 'components/Timeline/types'

const AvatarWithIcon: React.FC<{ avatar: AvatarWithIconT }> = ({ avatar }) => {
  return <Avatar avatar={avatar} />
}

export default AvatarWithIcon
